<template>
  <Layout>
    <LayoutPreviewSite>
      <slot />
    </LayoutPreviewSite>
  </Layout>
</template>

<script setup lang="ts">
/** components */
import Layout from '~/components/TheLayout.vue'
import LayoutPreviewSite from '~/components/PreviewSiteLayout.vue'
</script>
